module.exports = __webpack_public_path__ + "static/media/cot.da2f48d4.png";